import type { ReactNode } from "react";

/**
 * One acknowledgement — a checkbox with the paragraph it accepts.
 *
 * Unticked and unanswered look the same here on purpose: neither is an acceptance, and
 * nothing is stored for either. The certification body's agreements (screen 07) and the
 * auditor's declarations (screens 16 and 17) are the same object, so they are one
 * component — the paragraphs differ, the meaning of a tick does not.
 */
export function Acknowledgement({
  id,
  title,
  checked,
  error,
  onChange,
  children,
}: {
  id: string;
  title: string;
  checked: boolean;
  error?: string;
  onChange: (value: boolean) => void;
  children: ReactNode;
}) {
  return (
    <>
      <label className="ack" htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          aria-describedby={error ? `${id}-error` : undefined}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span>
          <b>{title}</b> {children}
        </span>
      </label>
      {error ? (
        <p className="err" id={`${id}-error`} role="alert">
          {error}
        </p>
      ) : null}
    </>
  );
}
